export const enum CommonGenericEvents {
	REMEMBER_PASSWORD_SEND = 'remember_password_send',
}
